import { count } from "console";
import { useFetchData } from "../../../hooks/useFetch";
import { BaseResponse } from "../../../models/response/base-response";
import { ApiConfig ,API_RECEIPT_CATEGORY_ROUTER} from "../../../services/api-config";
export interface ReceiptCategory {
    id: number;
    company_id: number;
    code: string;
    name: string;
    description?: string;
    type: number; // 1: Thu, 2: Chi
    debit_account?: number;
    credit_account?: number;
    vat_account?: number;
    status: number; // 0: Inactive, 1: Active
    reason?: string;
    created_at?: string;
    updated_at?: string;
  
    // Optional computed fields (tên tài khoản hiển thị)
    debit_account_name?: string;
    credit_account_name?: string;
  }
  
  export interface ReceiptCategoryListParams {
    page?: number;
    limit?: number;
    key_search?: string;
    type?: number | null; // 1: Thu, 2: Chi, null: tất cả
    status?: number; // 1: active, 0: inactive
  }
  export const ReceiptCategoryService = {
    list: () => {
        const { request, baseResponse, loading } = useFetchData.Get<ReceiptCategory>({
          projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE,
        });
    
        return {
          fetch: (params: ReceiptCategoryListParams = {}) => {
            const defaultParams = {
              page: 1,
              limit: 20,
              key_search: "",
              type: null,   // 1: Thu, 2: Chi, null: tất cả
              status: 1,    // 1: Hoạt động mặc định
              ...params,    // Gộp với param người dùng (ưu tiên giá trị người dùng)
            };
    
            return request({
              endPoint: API_RECEIPT_CATEGORY_ROUTER.API_RECEIPT_CATEGORY_LIST,
              data: defaultParams,
            });
          },
          response: baseResponse,
          loading: loading,
        };
      },
    create : () => {
      const { request, baseResponse, loading } = useFetchData.Post<BaseResponse<ReceiptCategory>>({
        projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE,
      });
      return {
        fetch: (payload: ReceiptCategory) =>
          request({
            endPoint: API_RECEIPT_CATEGORY_ROUTER.API_RECEIPT_CATEGORY_CREATE,
            data: payload,
          }),
        response: baseResponse,
        loading: loading,
      }
    },
    update : () => {
      const { request, baseResponse, loading } = useFetchData.Post<BaseResponse<ReceiptCategory>>({
        projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE,
      });
      return {
        fetch: (id: number, payload: ReceiptCategory) =>
          request({
            endPoint: API_RECEIPT_CATEGORY_ROUTER.API_RECEIPT_CATEGORY_UPDATE(id),
            data: payload,
          }),
        response: baseResponse,
        loading: loading,
      }
    },
    detail : () => {
      const { request, baseResponse, loading } = useFetchData.Get<ReceiptCategory>({
        projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE,
      });
      return {
        fetch: (id: number) =>
          request({
            endPoint: API_RECEIPT_CATEGORY_ROUTER.API_RECEIPT_CATEGORY_DETAIL(id),
          }),
        response: baseResponse,
        loading: loading,
      }
    },
    changeStatus : () => {
      const { request, baseResponse, loading } = useFetchData.Post<BaseResponse<ReceiptCategory>>({
        projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE,
      });
      return {
        fetch: (id: number, payload: ReceiptCategory) =>
          request({
            endPoint: API_RECEIPT_CATEGORY_ROUTER.API_RECEIPT_CATEGORY_CHANGE_STATUS(id),
            data: payload,
          }),
        response: baseResponse,
        loading: loading,
      }
    },
    countTab : () => {
      const { request, baseResponse, loading } = useFetchData.Get<{ active: number; inactive: number }>({
        projectId: ApiConfig.PROJECT_ID.ACCOUNTING_SERVICE,
      });
      return {
        fetch: (params: { key_search?: string; type?: number | null; }) =>
          request({ endPoint: API_RECEIPT_CATEGORY_ROUTER.API_RECEIPT_CATEGORY_COUNT_TAB, data: params }),
        response: baseResponse,
        loading,
      };
    }
  }